export default __webpack_public_path__ + "static/media/Success.ff4099ab.svg";